import * as d3 from 'd3';
import { FormattedLineChartData } from 'src/components/pages/EthicalHealthDataview/hooks';

interface Arguments {
  graph: d3.Selection<null, unknown, null, undefined>;
  data: FormattedLineChartData[];
  xScale: d3.ScaleBand<string | number>;
  yScale: d3.ScaleLinear<number, number, never>;
}

export const appendLines = ({ graph, data, xScale, yScale }: Arguments) => {
  const lines = d3.group(data, (d) => d.line);

  graph
    .selectAll('.data-line')
    .data(lines)
    .join('path')
    .attr('fill', 'none')
    .attr('stroke', (d) => d[1][0].color)
    .attr('stroke-width', 1)
    .attr(
      'd',
      (d1: [string, FormattedLineChartData[]]) =>
        d3
          .line<FormattedLineChartData>()
          .x((d) => Number(xScale(d.x)) + xScale.bandwidth() / 2)
          .y((d) => yScale(d.y))
          .defined((d) => d.y !== undefined && d.y !== null)(d1[1]), // 0 is still a valid value to render
    );
  graph
    .selectAll('.circle')
    .data(data)
    .enter()
    .append('circle')
    .attr('fill', (d) => d.color)
    .attr('r', (d) => (d.y !== undefined && d.y !== null ? 4.5 : 0)) // 0 is still a valid value to render
    .attr('cx', (d) => Number(xScale(d.x)) + xScale.bandwidth() / 2)
    .attr('cy', (d) => yScale(d.y));
};
